(function() {
    'use strict';
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    function init() {
        if (!document.getElementById('baseLayer')) {
            console.warn('Character builder elements not found');
            return;
        }
        function revealWhenLoaded(el) {
            if (!el) return;
            const reveal = () => { el.onload = null; el.onerror = null; el.style.display = 'block'; };
            el.onload = reveal;
            el.onerror = reveal;
            if (el.complete) reveal();
        }
        const hideScrollbarStyle = document.createElement('style');
        hideScrollbarStyle.textContent = `#variantOptions::-webkit-scrollbar,#variant2Options::-webkit-scrollbar{display:none;}`;
        if (!document.getElementById('hideScrollbarStyle')) {
            hideScrollbarStyle.id = 'hideScrollbarStyle';
            document.head.appendChild(hideScrollbarStyle);
        }
        const stylesBoy = HAIR_STYLES_BOY;
        const stylesGirl = HAIR_STYLES_GIRL;
        const glassesOptionsBoy = GLASSES_OPTIONS;
        const glassesOptionsGirl = GLASSES_OPTIONS_GIRL;
        const accessoriesOptionsBoy = ACCESSORIES_OPTIONS;
        const accessoriesOptionsGirl = ACCESSORIES_OPTIONS_GIRL;
        const eyebrowsOptionsBoy = EYEBROWS_OPTIONS;
        const eyebrowsOptionsGirl = EYEBROWS_OPTIONS_GIRL;
        const eyesOptionsBoy = EYES_OPTIONS;
        const eyesOptionsGirl = EYES_OPTIONS_GIRL;
        const skinTonesBoy = SKIN_TONES;
        const skinTonesGirl = SKIN_TONES_GIRL;
        const skinTonesGirlTenue2 = (typeof SKIN_TONES_GIRL_TENUE2 !== 'undefined') ? SKIN_TONES_GIRL_TENUE2 : SKIN_TONES_GIRL;
        const frecklesOptions = FRECKLES_OPTIONS;
        const colors = HAIR_COLORS;
        const eyesColors = EYES_COLORS;
        const IMG = BASE_IMAGES;
        let styles = stylesBoy;
        let glassesOptions = glassesOptionsBoy;
        let accessoriesOptions = accessoriesOptionsBoy;
        let eyebrowsOptions = eyebrowsOptionsBoy;
        let eyesOptions = eyesOptionsBoy;
        let skinTones = skinTonesBoy;
        let currentStepNum = 1;
        let gender = 'boy', styleIdx = 0, colorIdx = 0;
        let glassesIdx = 0, skinIdx = 0, frecklesIdx = 0, eyesIdx = 0, eyebrowsIdx = 0, accessoriesIdx = 0;
        let outfitIdx = 0;
        let savedStyleIdx = -1;
        let prevAccessoriesIdx = -1;
        let currentCategory = 'hair';
        let catList = ['outfit', 'skin', 'hair', 'accessories', 'glasses', 'freckles', 'eyes'];
        let catIndex = catList.indexOf('hair');
        let cat2Index = catList.indexOf('hair');
        let hasSecondaryCharacter = false;
        let gender2 = 'boy', styleIdx2 = 0, colorIdx2 = 0;
        let glassesIdx2 = 0, skinIdx2 = 0, frecklesIdx2 = 0, eyesIdx2 = 0, eyebrowsIdx2 = 0, accessoriesIdx2 = 0;
        let outfitIdx2 = 0;
        let savedStyleIdx2 = -1;
        let prevAccessoriesIdx2 = -1;
        function nearestAllowed(idx, allowed, hairStyles) {
            if (!allowed || !allowed.length) return idx;
            if (allowed.indexOf(idx) !== -1) return idx;
            var closest = function (list) {
                return list.reduce(function(best, a) {
                    return Math.abs(a - idx) < Math.abs(best - idx) ? a : best;
                }, list[0]);
            };
            if (hairStyles && hairStyles[idx] && hairStyles[idx].length) {
                var wantedLength = hairStyles[idx].length;
                var sameLength = allowed.filter(function(a) {
                    return hairStyles[a] && hairStyles[a].length === wantedLength;
                });
                if (sameLength.length) return closest(sameLength);
            }
            return closest(allowed);
        }
        let currentCategory2 = 'hair';
        window.characterBuilder = {
            get gender() { return gender; },
            get styleIdx() { return styleIdx; },
            get colorIdx() { return colorIdx; },
            get glassesIdx() { return glassesIdx; },
            get skinIdx() { return skinIdx; },
            get frecklesIdx() { return frecklesIdx; },
            get eyesIdx() { return eyesIdx; },
            get eyebrowsIdx() { return eyebrowsIdx; },
            get accessoriesIdx() { return accessoriesIdx; },
            get gender2() { return gender2; },
            get styleIdx2() { return styleIdx2; },
            get colorIdx2() { return colorIdx2; },
            get glassesIdx2() { return glassesIdx2; },
            get skinIdx2() { return skinIdx2; },
            get frecklesIdx2() { return frecklesIdx2; },
            get eyesIdx2() { return eyesIdx2; },
            get eyebrowsIdx2() { return eyebrowsIdx2; },
            get accessoriesIdx2() { return accessoriesIdx2; }
        };
        let styles2 = stylesBoy;
        let glassesOptions2 = glassesOptionsBoy;
        let accessoriesOptions2 = accessoriesOptionsBoy;
        let eyebrowsOptions2 = eyebrowsOptionsBoy;
        let eyesOptions2 = eyesOptionsBoy;
        let skinTones2 = skinTonesBoy;
        let isInitialLoad = true;
        let handleScrollFunc = null;
        const hair = document.getElementById('hairLayer');
        const eyebrows = document.getElementById('eyebrowsLayer');
        const glasses = document.getElementById('glassesLayer');
        const accessories = document.getElementById('accessoriesLayer');
        const skin = document.getElementById('skinLayer');
        const freckles = document.getElementById('frecklesLayer');
        const eyes = document.getElementById('eyesLayer');
        const baseLayer = document.getElementById('baseLayer');
        const hair2 = document.getElementById('hair2Layer');
        const eyebrows2 = document.getElementById('eyebrows2Layer');
        const glasses2 = document.getElementById('glasses2Layer');
        const accessories2 = document.getElementById('accessories2Layer');
        const skin2 = document.getElementById('skin2Layer');
        const freckles2 = document.getElementById('freckles2Layer');
        const eyes2 = document.getElementById('eyes2Layer');
        const base2Layer = document.getElementById('base2Layer');
        const secondaryCheckbox = document.getElementById('secondaryCheckbox');
        if (secondaryCheckbox) {
            secondaryCheckbox.checked = false;
            hasSecondaryCharacter = false;
            secondaryCheckbox.onchange = function() {
                hasSecondaryCharacter = this.checked;
                updateProgressBar();
                updateNextButton();
            };
        }
        function updateNextButton() {
            const nextBtn = document.getElementById('nextBtn');
            if (nextBtn && currentStepNum === 3) {
                nextBtn.textContent = hasSecondaryCharacter ? 'Continuer' : 'Non merci, continuer';
            }
        }
        function updateProgressBar() {
            const step4 = document.getElementById('step4Progress');
            const step5 = document.getElementById('step5Progress');
            const coverNum = document.getElementById('coverStepNum');
            const recapNum = document.getElementById('recapStepNum');
            if (hasSecondaryCharacter) {
                if (step4) step4.style.display = 'flex';
                if (step5) step5.style.display = 'flex';
                if (coverNum) coverNum.textContent = '6';
                if (recapNum) recapNum.textContent = '7';
            } else {
                if (step4) step4.style.display = 'none';
                if (step5) step5.style.display = 'none';
                if (coverNum) coverNum.textContent = '4';
                if (recapNum) recapNum.textContent = '5';
            }
        }
        function getAbonnementChoice() {
            try {
                return JSON.parse(sessionStorage.getItem('lv_abonnement_choice') || 'null');
            } catch (e) {
                return null;
            }
        }
        function renderVariants() {
            const variantOptions = document.getElementById('variantOptions');
            const colorOptions = document.getElementById('colorOptions');
            if (!variantOptions || !colorOptions) return;
            variantOptions.innerHTML = '';
            colorOptions.innerHTML = '';
            let options = [];
            let showColors = false;
            let showEyesColors = false;
            if (currentCategory === 'hair') { options = styles; showColors = true; }
            else if (currentCategory === 'accessories') options = accessoriesOptions;
            else if (currentCategory === 'glasses') options = glassesOptions;
            else if (currentCategory === 'skin') options = skinTones;
            else if (currentCategory === 'freckles') options = frecklesOptions;
            else if (currentCategory === 'eyes') { options = eyesOptions; showEyesColors = true; }
            else if (currentCategory === 'eyebrows') { options = eyebrowsOptions; showColors = true; }
            else if (currentCategory === 'outfit') options = (typeof OUTFITS_GIRL !== 'undefined') ? OUTFITS_GIRL : [];
            let currentIdx = 0;
            if (currentCategory === 'hair') currentIdx = styleIdx;
            else if (currentCategory === 'accessories') currentIdx = accessoriesIdx;
            else if (currentCategory === 'glasses') currentIdx = glassesIdx;
            else if (currentCategory === 'skin') currentIdx = skinIdx;
            else if (currentCategory === 'freckles') currentIdx = frecklesIdx;
            else if (currentCategory === 'eyes') currentIdx = eyesIdx;
            else if (currentCategory === 'eyebrows') currentIdx = eyebrowsIdx;
            else if (currentCategory === 'outfit') currentIdx = outfitIdx;
            variantOptions.style.cssText = 'display:flex;gap:8px;align-items:center;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;padding:4px 0;scrollbar-width:none;-ms-overflow-style:none;';
            for (let i = 0; i < options.length; i++) {
                    const option = options[i];
                    const btn = document.createElement('button');
                    const isSelected = i === currentIdx;
                    const scale = isSelected ? 1.1 : 1;
                    const borderStyle = isSelected ? 'box-shadow:inset 0 0 0 3px #C1E5F1,0 2px 8px rgba(193,229,241,0.5);' : 'box-shadow:inset 0 0 0 2px #E5E5E5;';
                    btn.style.cssText = 'width:40px;height:40px;border-radius:50%;background:white;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:20px;transition:all 0.3s ease;flex-shrink:0;transform:scale('+scale+');opacity:1;overflow:hidden;scroll-snap-align:center;'+borderStyle;
                    if (option.icon) btn.textContent = option.icon;
                    else if (option.color && currentCategory === 'skin') btn.style.background = option.color;
                    else if (option.color && currentCategory === 'eyes') btn.style.background = option.color;
                    else if (currentCategory === 'hair' && (option.icon_url || option.colors)) {
                        const colorData = option.colors[colors[colorIdx].id];
                        const displayUrl = option.icon_url || (colorData ? colorData.url : null);
                        if (displayUrl && !displayUrl.includes('URL_')) {
                            btn.style.backgroundImage = 'url('+displayUrl+')';
                            btn.style.backgroundSize = '70% 70%';
                            btn.style.backgroundRepeat = 'no-repeat';
                            btn.style.backgroundPosition = 'center';
                        } else btn.textContent = option.name.charAt(0);
                    } else if (option.url && !option.url.includes('URL_') && option.url !== '') {
                        btn.style.backgroundImage = 'url('+option.url+')';
                        btn.style.backgroundSize = 'contain';
                        btn.style.backgroundRepeat = 'no-repeat';
                        btn.style.backgroundPosition = 'center';
                    } else btn.textContent = option.name.charAt(0);
                    let isBlocked = false;
                    if (currentCategory === 'hair' && accessoriesIdx > 0) {
                        const activeAcc = accessoriesOptions[accessoriesIdx];
                        if (activeAcc.hideHair) isBlocked = true;
                        else if (activeAcc.allowedHair && activeAcc.allowedHair.length && activeAcc.allowedHair.indexOf(i) === -1) isBlocked = true;
                    }
                    if (isBlocked) {
                        btn.style.opacity = '0.3';
                        btn.style.cursor = 'not-allowed';
                        btn.style.filter = 'grayscale(1)';
                    }
                    btn.onclick = () => {
                        if (isBlocked) return;
                        if (currentCategory === 'hair') styleIdx = i;
                        else if (currentCategory === 'accessories') accessoriesIdx = i;
                        else if (currentCategory === 'glasses') glassesIdx = i;
                        else if (currentCategory === 'skin') skinIdx = i;
                        else if (currentCategory === 'freckles') frecklesIdx = i;
                        else if (currentCategory === 'eyes') eyesIdx = i;
                        else if (currentCategory === 'eyebrows') eyebrowsIdx = i;
                        else if (currentCategory === 'outfit') { outfitIdx = i; skinTones = outfitIdx === 0 ? skinTonesGirl : skinTonesGirlTenue2; }
                        update();
                    };
                    variantOptions.appendChild(btn);
                }
            if (showColors) {
                colors.forEach((c,i) => {
                    const btn = document.createElement('button');
                    const isSelected = i === colorIdx;
                    btn.style.cssText = 'width:40px;height:40px;border-radius:50%;background:'+c.color+';border:2px solid '+(isSelected?'#C1E5F1':'#E5E5E5')+';cursor:pointer;transition:transform 0.15s;flex-shrink:0;'+(isSelected?' box-shadow:0 2px 8px rgba(193,229,241,0.3);':'');
                    btn.onmouseenter = () => { btn.style.transform = 'scale(1.15)'; };
                    btn.onmouseleave = () => { btn.style.transform = 'scale(1)'; };
                    btn.onclick = () => { colorIdx = i; update(); };
                    colorOptions.appendChild(btn);
                });
                document.getElementById('colorRow').style.display = 'flex';
            } else {
                const colorRow = document.getElementById('colorRow');
                if (colorRow) colorRow.style.display = 'none';
            }
            const eyesColorRowEl = document.getElementById('eyesColorRow');
            if (eyesColorRowEl) eyesColorRowEl.style.display = 'none';
        }
        function update() {
            renderVariants();
            const controlTitle = document.querySelector('#hairControls > div');
            if (controlTitle) {
                if (currentCategory === 'hair') controlTitle.textContent = 'Ajuster Cheveux';
                else if (currentCategory === 'accessories') controlTitle.textContent = 'Ajuster Accessoires';
                else if (currentCategory === 'glasses') controlTitle.textContent = 'Ajuster Lunettes';
                else if (currentCategory === 'freckles') controlTitle.textContent = 'Ajuster Taches';
                else controlTitle.textContent = 'Ajuster';
            }
            const st = styles[styleIdx];
            if (st.id === 'none') {
                if (hair) hair.style.display = 'none';
            } else {
                if (hair) {
                    const colorData = st.colors[colors[colorIdx].id];
                    if (colorData && colorData.url && !colorData.url.includes('URL_')) {
                        const settings = colorData.settings;
                        hair.style.top = settings.top + '%';
                        hair.style.left = '50%';
                        const leftOffset = settings.left || 0;
                        hair.style.transform = 'translateX(calc(-50% + '+leftOffset+'px)) scale('+(settings.scale/100)+')';
                        hair.style.opacity = '1';
                        if (hair.getAttribute('src') !== colorData.url) { hair.style.display = 'none'; hair.src = colorData.url; revealWhenLoaded(hair); }
                        else hair.style.display = 'block';
                        const scaleSlider = document.getElementById('scaleSlider');
                        const topSlider = document.getElementById('topSlider');
                        const leftSlider = document.getElementById('leftSlider');
                        const scaleValue = document.getElementById('scaleValue');
                        const topValue = document.getElementById('topValue');
                        const leftValue = document.getElementById('leftValue');
                        if (scaleSlider) { scaleSlider.value = settings.scale; scaleValue.textContent = settings.scale; }
                        if (topSlider) { topSlider.value = settings.top; topValue.textContent = settings.top; }
                        if (leftSlider) { leftSlider.value = leftOffset; leftValue.textContent = leftOffset; }
                    } else hair.style.display = 'none';
                }
            }
            const gl = glassesOptions[glassesIdx];
            if (glasses) {
                if (gl.url) {
                    const newGlassesSrc = glasses.getAttribute('src') !== gl.url;
                    if (newGlassesSrc) { glasses.style.display = 'none'; glasses.src = gl.url; }
                    if (gl.settings) {
                        const settings = gl.settings;
                        glasses.style.top = settings.top + '%';
                        glasses.style.left = '50%';
                        const leftOffset = settings.left || 0;
                        glasses.style.transform = 'translateX(calc(-50% + '+leftOffset+'px)) scale('+(settings.scale/100)+')';
                        glasses.style.opacity = '1';
                        const scaleSlider = document.getElementById('scaleSlider');
                        const topSlider = document.getElementById('topSlider');
                        const leftSlider = document.getElementById('leftSlider');
                        const scaleValue = document.getElementById('scaleValue');
                        const topValue = document.getElementById('topValue');
                        const leftValue = document.getElementById('leftValue');
                        if (scaleSlider) { scaleSlider.value = settings.scale; scaleValue.textContent = settings.scale; }
                        if (topSlider) { topSlider.value = settings.top; topValue.textContent = settings.top; }
                        if (leftSlider) { leftSlider.value = leftOffset; leftValue.textContent = leftOffset; }
                    }
                    if (newGlassesSrc) revealWhenLoaded(glasses); else glasses.style.display = 'block';
                } else glasses.style.display = 'none';
            }
            const acc = accessoriesOptions[accessoriesIdx];
            function renderHair1() {
                const st = styles[styleIdx];
                if (!hair) return;
                if (st && st.id === 'none') { hair.style.display = 'none'; return; }
                const cd = st && st.colors ? st.colors[colors[colorIdx].id] : null;
                if (cd && cd.url && !cd.url.includes('URL_')) {
                    const s = cd.settings;
                    hair.style.top = s.top + '%';
                    hair.style.left = '50%';
                    const lo = s.left || 0;
                    hair.style.transform = 'translateX(calc(-50% + '+lo+'px)) scale('+(s.scale/100)+')';
                    hair.style.opacity = '1';
                    if (hair.getAttribute('src') !== cd.url) { hair.style.display = 'none'; hair.src = cd.url; revealWhenLoaded(hair); }
                    else hair.style.display = 'block';
                } else hair.style.display = 'none';
            }
            if (accessories) {
                if (accessoriesIdx > 0) {
                    if (savedStyleIdx < 0) savedStyleIdx = styleIdx;
                    if (acc.url) {
                        const newAccSrc = accessories.getAttribute('src') !== acc.url;
                        if (newAccSrc) { accessories.style.display = 'none'; accessories.src = acc.url; }
                        if (acc.settings) {
                            const settings = acc.settings;
                            accessories.style.top = settings.top + '%';
                            accessories.style.left = '50%';
                            const leftOffset = settings.left || 0;
                            accessories.style.transform = 'translateX(calc(-50% + '+leftOffset+'px)) scale('+(settings.scale/100)+')';
                            accessories.style.opacity = '1';
                            const scaleSlider = document.getElementById('scaleSlider');
                            const topSlider = document.getElementById('topSlider');
                            const leftSlider = document.getElementById('leftSlider');
                            const scaleValue = document.getElementById('scaleValue');
                            const topValue = document.getElementById('topValue');
                            const leftValue = document.getElementById('leftValue');
                            if (scaleSlider) { scaleSlider.value = settings.scale; scaleValue.textContent = settings.scale; }
                            if (topSlider) { topSlider.value = settings.top; topValue.textContent = settings.top; }
                            if (leftSlider) { leftSlider.value = leftOffset; leftValue.textContent = leftOffset; }
                        }
                        if (newAccSrc) revealWhenLoaded(accessories); else accessories.style.display = 'block';
                    } else {
                        accessories.style.display = 'none';
                    }
                    const justChanged = prevAccessoriesIdx !== accessoriesIdx;
                    if (acc.hideHair) {
                        if (hair) hair.style.display = 'none';
                    } else if (acc.allowedHair && acc.allowedHair.length) {
                        if (justChanged) {
                            const base = (savedStyleIdx >= 0) ? savedStyleIdx : styleIdx;
                            styleIdx = nearestAllowed(base, acc.allowedHair, styles);
                        }
                        renderHair1();
                    } else {
                        if (justChanged) {
                            const buzzIdx = styles.findIndex(s => s.id === 'buzz');
                            if (buzzIdx !== -1) styleIdx = buzzIdx;
                        }
                        renderHair1();
                    }
                } else {
                    accessories.style.display = 'none';
                    if (savedStyleIdx >= 0) {
                        styleIdx = savedStyleIdx;
                        savedStyleIdx = -1;
                        renderHair1();
                    }
                }
                prevAccessoriesIdx = accessoriesIdx;
            }
            const eb = eyebrowsOptions[eyebrowsIdx];
            if (eb.id === 'none') {
                if (eyebrows) eyebrows.style.display = 'none';
            } else {
                if (eyebrows) {
                    const colorData = eb.colors[colors[colorIdx].id];
                    if (colorData && colorData.url && !colorData.url.includes('URL_')) {
                        const newEyebrowsSrc = eyebrows.getAttribute('src') !== colorData.url;
                        if (newEyebrowsSrc) { eyebrows.style.display = 'none'; eyebrows.src = colorData.url; }
                        const settings = colorData.settings;
                        const scaleSlider = document.getElementById('scaleSlider');
                        const topSlider = document.getElementById('topSlider');
                        const leftSlider = document.getElementById('leftSlider');
                        const scaleValue = document.getElementById('scaleValue');
                        const topValue = document.getElementById('topValue');
                        const leftValue = document.getElementById('leftValue');
                        if (currentCategory === 'hair' && gender === 'girl' && scaleSlider && topSlider && leftSlider) {
                            scaleSlider.value = settings.scale;
                            topSlider.value = settings.top;
                            leftSlider.value = settings.left || 0;
                            if (scaleValue) scaleValue.textContent = settings.scale;
                            if (topValue) topValue.textContent = settings.top;
                            if (leftValue) leftValue.textContent = settings.left || 0;
                            eyebrows.style.top = settings.top + '%';
                            eyebrows.style.left = '50%';
                            eyebrows.style.transform = 'translateX(calc(-50% + '+(settings.left || 0)+'px)) scale('+(settings.scale/100)+')';
                        }
                        else if (currentCategory === 'eyebrows' && scaleSlider && topSlider && leftSlider) {
                            const finalScale = parseFloat(scaleSlider.value);
                            const finalTop = parseFloat(topSlider.value);
                            const finalLeft = parseFloat(leftSlider.value);
                            eyebrows.style.top = finalTop + '%';
                            eyebrows.style.left = '50%';
                            eyebrows.style.transform = 'translateX(calc(-50% + '+finalLeft+'px)) scale('+(finalScale/100)+')';
                            if (scaleValue) scaleValue.textContent = finalScale;
                            if (topValue) topValue.textContent = finalTop;
                            if (leftValue) leftValue.textContent = finalLeft;
                        } 
                        else {
                            eyebrows.style.top = settings.top + '%';
                            eyebrows.style.left = '50%';
                            const leftOffset = settings.left || 0;
                            eyebrows.style.transform = 'translateX(calc(-50% + '+leftOffset+'px)) scale('+(settings.scale/100)+')';
                        }
                        if (newEyebrowsSrc) revealWhenLoaded(eyebrows); else eyebrows.style.display = 'block';
                        eyebrows.style.opacity = '1';
                    } else eyebrows.style.display = 'none';
                }
            }
            const sk = skinTones[skinIdx];
            if (skin) {
                if (sk.url) {
                    if (skin.getAttribute('src') !== sk.url) { skin.style.display = 'none'; skin.src = sk.url; revealWhenLoaded(skin); }
                    else skin.style.display = 'block';
                    if (baseLayer) baseLayer.style.display = 'none';
                }
                else { skin.style.display = 'none'; if (baseLayer) baseLayer.style.display = 'block'; }
            }
            const fr = frecklesOptions[frecklesIdx];
            if (freckles) {
                if (fr.url) {
                    const newFrecklesSrc = freckles.getAttribute('src') !== fr.url;
                    if (newFrecklesSrc) { freckles.style.display = 'none'; freckles.src = fr.url; }
                    if (fr.settings) {
                        const settings = fr.settings;
                        freckles.style.top = settings.top + '%';
                        freckles.style.left = '50%';
                        const leftOffset = settings.left || 0;
                        freckles.style.transform = 'translateX(calc(-50% + '+leftOffset+'px)) scale('+(settings.scale/100)+')';
                        freckles.style.opacity = '1';
                        const scaleSlider = document.getElementById('scaleSlider');
                        const topSlider = document.getElementById('topSlider');
                        const leftSlider = document.getElementById('leftSlider');
                        const scaleValue = document.getElementById('scaleValue');
                        const topValue = document.getElementById('topValue');
                        const leftValue = document.getElementById('leftValue');
                        if (scaleSlider) { scaleSlider.value = settings.scale; scaleValue.textContent = settings.scale; }
                        if (topSlider) { topSlider.value = settings.top; topValue.textContent = settings.top; }
                        if (leftSlider) { leftSlider.value = leftOffset; leftValue.textContent = leftOffset; }
                        if (newFrecklesSrc) revealWhenLoaded(freckles); else freckles.style.display = 'block';
                    } else {
                        if (newFrecklesSrc) revealWhenLoaded(freckles); else freckles.style.display = 'block';
                    }
                } else freckles.style.display = 'none';
            }
            const ey = eyesOptions[eyesIdx];
            if (eyes) {
                if (ey.url && !ey.url.includes('URL_') && ey.url !== '') {
                    const newEyesSrc = eyes.getAttribute('src') !== ey.url;
                    if (newEyesSrc) { eyes.style.display = 'none'; eyes.src = ey.url; }
                    const settings = ey.settings;
                    eyes.style.top = settings.top + '%';
                    eyes.style.left = '50%';
                    const leftOffset = settings.left || 0;
                    eyes.style.transform = 'translateX(calc(-50% + '+leftOffset+'px)) scale('+(settings.scale/100)+')';
                    eyes.style.opacity = '1';
                    if (newEyesSrc) revealWhenLoaded(eyes); else eyes.style.display = 'block';
                } else eyes.style.display = 'none';
            }
        }
        let genderList = ['boy', 'girl'];
        const variantPrevBtn = document.getElementById('variantPrev');
        function isHairBlocked(idx) {
            if (accessoriesIdx <= 0) return false;
            const acc = accessoriesOptions[accessoriesIdx];
            if (acc.hideHair) return true;
            return !!(acc.allowedHair && acc.allowedHair.length && acc.allowedHair.indexOf(idx) === -1);
        }
        if (variantPrevBtn) variantPrevBtn.onclick = () => {
            if (currentCategory === 'hair' && styleIdx > 0 && !isHairBlocked(styleIdx - 1)) styleIdx--;
            else if (currentCategory === 'accessories' && accessoriesIdx > 0) accessoriesIdx--;
            else if (currentCategory === 'glasses' && glassesIdx > 0) glassesIdx--;
            else if (currentCategory === 'skin' && skinIdx > 0) skinIdx--;
            else if (currentCategory === 'freckles' && frecklesIdx > 0) frecklesIdx--;
            else if (currentCategory === 'eyes' && eyesIdx > 0) eyesIdx--;
            update();
        };
        const variantNextBtn = document.getElementById('variantNext');
        if (variantNextBtn) variantNextBtn.onclick = () => {
            if (currentCategory === 'hair' && styleIdx < styles.length - 1 && !isHairBlocked(styleIdx + 1)) styleIdx++;
            else if (currentCategory === 'accessories' && accessoriesIdx < accessoriesOptions.length - 1) accessoriesIdx++;
            else if (currentCategory === 'glasses' && glassesIdx < glassesOptions.length - 1) glassesIdx++;
            else if (currentCategory === 'skin' && skinIdx < skinTones.length - 1) skinIdx++;
            else if (currentCategory === 'freckles' && frecklesIdx < frecklesOptions.length - 1) frecklesIdx++;
            else if (currentCategory === 'eyes' && eyesIdx < eyesOptions.length - 1) eyesIdx++;
            update();
        };
        const colorPrevBtn = document.getElementById('colorPrev');
        if (colorPrevBtn) colorPrevBtn.onclick = () => { if (colorIdx > 0) colorIdx--; update(); };
        const colorNextBtn = document.getElementById('colorNext');
        if (colorNextBtn) colorNextBtn.onclick = () => { if (colorIdx < colors.length - 1) colorIdx++; update(); };
        document.querySelectorAll('[id*="Prev"], [id*="Next"]').forEach(btn => {
            btn.onmouseenter = () => { btn.style.borderColor = '#C1E5F1'; btn.style.background = '#F8FCFD'; };
            btn.onmouseleave = () => { btn.style.borderColor = '#E5E5E5'; btn.style.background = 'white'; };
        });
        document.querySelectorAll('.compact-category-btn').forEach((btn,i) => {
            btn.onclick = () => { if (btn.disabled) return; catIndex = i; updateCategory(); };
        });
        const categoryPrevBtn = document.getElementById('categoryPrev');
        if (categoryPrevBtn) categoryPrevBtn.onclick = () => { catIndex = (catIndex - 1 + catList.length) % catList.length; updateCategory(); };
        const categoryNextBtn = document.getElementById('categoryNext');
        if (categoryNextBtn) categoryNextBtn.onclick = () => { catIndex = (catIndex + 1) % catList.length; updateCategory(); };
        function updateCategory() {
            currentCategory = catList[catIndex];
            document.querySelectorAll('.compact-category-btn').forEach((b,i) => {
                if (i === catIndex && !b.disabled) { b.classList.add('active'); b.style.borderColor = '#C1E5F1'; b.style.boxShadow = '0 2px 8px rgba(193, 229, 241, 0.3)'; }
                else { b.classList.remove('active'); b.style.borderColor = '#E5E5E5'; b.style.boxShadow = 'none'; }
            });
            const labels = { hair: 'Coiffure', accessories: 'Accessoires', glasses: 'Lunettes', skin: 'Couleur de peau', freckles: 'Tâches de rousseur', eyes: 'Yeux', outfit: 'Tenue' };
            const categoryLabelEl = document.getElementById('categoryLabel');
            if (categoryLabelEl) categoryLabelEl.textContent = labels[currentCategory];
            const hairCompatInfoEl = document.getElementById('hairCompatInfo');
            if (hairCompatInfoEl) {
                if (currentCategory === 'accessories') {
                    hairCompatInfoEl.style.visibility = 'visible';
                    hairCompatInfoEl.textContent = gender === 'girl'
                        ? 'ℹ️ Certaines coiffures ne sont pas compatibles avec ce couvre-chef'
                        : 'ℹ️ La coiffure s\'adapte automatiquement au couvre-chef choisi';
                } else {
                    hairCompatInfoEl.style.visibility = 'hidden';
                }
            }
            const hairControls = document.getElementById('hairControls');
            const controlsTitle = document.getElementById('controlsTitle');
            if (hairControls && controlsTitle) {
                if (currentCategory === 'hair' || currentCategory === 'accessories' || currentCategory === 'glasses') {
                    hairControls.style.display = 'flex';
                    const titles = { hair: 'Ajuster Cheveux', accessories: 'Ajuster Accessoires', glasses: 'Ajuster Lunettes' };
                    controlsTitle.textContent = titles[currentCategory] || 'Ajuster';
                } else {
                    hairControls.style.display = 'none';
                }
            }
            update();
        }
        let genderIndex = 0;
        document.querySelectorAll('.compact-gender-btn').forEach((btn,i) => {
            btn.onclick = () => { genderIndex = i; updateGender(); };
        });
        const genderPrevBtn = document.getElementById('genderPrev');
        if (genderPrevBtn) genderPrevBtn.onclick = () => { genderIndex = (genderIndex - 1 + genderList.length) % genderList.length; updateGender(); };
        const genderNextBtn = document.getElementById('genderNext');
        if (genderNextBtn) genderNextBtn.onclick = () => { genderIndex = (genderIndex + 1) % genderList.length; updateGender(); };
        function updateGender() {
            gender = genderList[genderIndex];
            styles = (gender === 'boy') ? stylesBoy : stylesGirl;
            glassesOptions = (gender === 'boy') ? glassesOptionsBoy : glassesOptionsGirl;
            accessoriesOptions = (gender === 'boy') ? accessoriesOptionsBoy : accessoriesOptionsGirl;
            eyebrowsOptions = (gender === 'boy') ? eyebrowsOptionsBoy : eyebrowsOptionsGirl;
            eyesOptions = (gender === 'boy') ? eyesOptionsBoy : eyesOptionsGirl;
            outfitIdx = 0;
            skinTones = (gender === 'boy') ? skinTonesBoy : skinTonesGirl;
            styleIdx = 0;
            const outfitCatBtn = document.querySelector('.compact-category-btn[data-category="outfit"]');
            if (outfitCatBtn) {
                outfitCatBtn.style.display = gender === 'girl' ? 'flex' : 'none';
                if (gender !== 'girl' && currentCategory === 'outfit') { catIndex = catList.indexOf('hair'); updateCategory(); }
            }
            const hairCompatInfoElG = document.getElementById('hairCompatInfo');
            if (hairCompatInfoElG && currentCategory === 'accessories') {
                hairCompatInfoElG.textContent = gender === 'girl'
                    ? 'ℹ️ Certaines coiffures ne sont pas compatibles avec ce couvre-chef'
                    : 'ℹ️ La coiffure s\'adapte automatiquement au couvre-chef choisi';
            }
            document.querySelectorAll('.compact-gender-btn').forEach((b,i) => {
                if (i === genderIndex) { b.classList.add('active'); b.style.borderColor = '#C1E5F1'; b.style.background = '#F8FCFD'; b.style.boxShadow = '0 2px 8px rgba(193, 229, 241, 0.3)'; }
                else { b.classList.remove('active'); b.style.borderColor = '#E5E5E5'; b.style.background = 'white'; b.style.boxShadow = 'none'; }
            });
            if (baseLayer) {
                if (skin) skin.style.display = 'none';
                if (hair) hair.style.display = 'none';
                if (glasses) glasses.style.display = 'none';
                if (freckles) freckles.style.display = 'none';
                if (eyes) eyes.style.display = 'none';
                baseLayer.style.opacity = '0';
                setTimeout(() => { baseLayer.src = gender === 'boy' ? IMG.base_boy : IMG.base_girl; setTimeout(() => { baseLayer.style.opacity = '1'; update(); }, 50); }, 300);
            }
        }
        function showStep(stepNum) {
            if (!isInitialLoad) {
                const progressContainer = document.querySelector('.progress-container');
                if (progressContainer) progressContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            isInitialLoad = false;
            document.querySelectorAll('.step').forEach(s => s.classList.remove('active'));
            const step1 = document.getElementById('step1');
            const step2 = document.getElementById('step2');
            const stepRecap = document.getElementById('stepRecap');
            const bubblePerso1 = document.querySelector('[data-step="perso1"]');
            const bubbleRecap = document.querySelector('[data-step="recap"]');
            document.querySelectorAll('.progress-step').forEach(s => s.classList.remove('active'));
            if (stepNum === 1 && step1) {
                step1.classList.add('active');
                if (bubblePerso1) { bubblePerso1.classList.add('active'); updateStepProgress(bubblePerso1, 0); }
            }
            else if (stepNum === 2 && step2) {
                step2.classList.add('active');
                if (bubblePerso1) { bubblePerso1.classList.add('active'); updateStepProgress(bubblePerso1, 0.5); }
            }
            else if (stepNum === 3 && stepRecap) {
                stepRecap.classList.add('active');
                updateRecap();
                if (bubblePerso1) updateStepProgress(bubblePerso1, 1);
                if (bubbleRecap) bubbleRecap.classList.add('active');
            }
            const totalSteps = 3;
            const progressBarEl = document.getElementById('progressBar');
            if (progressBarEl) progressBarEl.style.width = ((stepNum / totalSteps) * 100) + '%';
            const prevBtnEl = document.getElementById('prevBtn');
            const nextBtnEl = document.getElementById('nextBtn');
            const validateBtnEl = document.getElementById('validateBtn');
            if (prevBtnEl) prevBtnEl.style.display = stepNum > 1 ? 'block' : 'none';
            if (nextBtnEl) {
                nextBtnEl.style.display = stepNum < totalSteps ? 'block' : 'none';
                nextBtnEl.textContent = 'Continuer';
            }
            if (validateBtnEl) validateBtnEl.style.display = stepNum === totalSteps ? 'block' : 'none';
            currentStepNum = stepNum;
            updateProgressLabels();
            if (typeof handleScrollFunc === 'function') handleScrollFunc();
        }
        function updateProgressLabels() {
            function capitalize(str) {
                if (!str) return str;
                return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
            }
            const prenomEl = document.getElementById('prenom');
            const step1Label = document.getElementById('step1Label');
            if (prenomEl && step1Label) {
                const prenom = prenomEl.value.trim();
                step1Label.textContent = prenom ? capitalize(prenom) : 'Personnage principal';
            }
            const prenomSecEl = document.getElementById('prenomSecondaire');
            const choiceLabel = document.getElementById('choiceLabel');
            if (hasSecondaryCharacter && prenomSecEl && choiceLabel) {
                const prenomSec = prenomSecEl.value.trim();
                choiceLabel.textContent = prenomSec ? capitalize(prenomSec) : 'Personnage secondaire';
            } else if (choiceLabel && !hasSecondaryCharacter) {
                choiceLabel.textContent = 'Personnage secondaire ?';
            }
            if (hasSecondaryCharacter) {
                const step4Label = document.getElementById('step4Label');
                if (prenomSecEl && step4Label) {
                    const prenomSec = prenomSecEl.value.trim();
                    step4Label.textContent = prenomSec ? capitalize(prenomSec) : 'Personnage secondaire';
                }
            }
        }
        function updateRecap() {
            const prenomEl = document.getElementById('prenom');
            const ageEl = document.getElementById('age');
            const prenom = prenomEl ? prenomEl.value : '-';
            const age = ageEl ? ageEl.value : '-';
            const genderName = gender === 'boy' ? 'Garçon' : 'Fille';
            const choice = getAbonnementChoice();
            const recapPrenomEl = document.getElementById('recapPrenom');
            const recapAgeEl = document.getElementById('recapAge');
            const recapGenreEl = document.getElementById('recapGenre');
            const recapCouvertureEl = document.getElementById('recapCouverture');
            const recapPrixEl = document.getElementById('recapPrix');
            if (recapPrenomEl) recapPrenomEl.textContent = prenom;
            if (recapAgeEl) recapAgeEl.textContent = age ? age + ' ans' : '-';
            if (recapGenreEl) recapGenreEl.textContent = genderName;
            if (recapCouvertureEl) recapCouvertureEl.textContent = choice ? choice.label : '-';
            if (recapPrixEl) recapPrixEl.textContent = choice ? ('€' + choice.price + ' ' + choice.period) : '-';
            const recapPrimaryTitle = document.getElementById('recapPrimaryTitle');
            if (recapPrimaryTitle && prenom && prenom !== '-') recapPrimaryTitle.textContent = prenom;
            if (hasSecondaryCharacter) {
                const prenomSecEl = document.getElementById('prenomSecondaire');
                const ageSecEl = document.getElementById('ageSecondaire');
                const lienSecEl = document.getElementById('lienSecondaire');
                const prenomSec = prenomSecEl ? prenomSecEl.value : '-';
                const ageSec = ageSecEl ? ageSecEl.value : '-';
                const lienSec = lienSecEl ? lienSecEl.value : '-';
                const recapPrenomSecEl = document.getElementById('recapPrenomSecondaire');
                const recapAgeSecEl = document.getElementById('recapAgeSecondaire');
                const recapLienSecEl = document.getElementById('recapLienSecondaire');
                if (recapPrenomSecEl) recapPrenomSecEl.textContent = prenomSec;
                if (recapAgeSecEl) recapAgeSecEl.textContent = ageSec ? ageSec + ' ans' : '-';
                if (recapLienSecEl) recapLienSecEl.textContent = lienSec;
                const recapSecondaryTitle = document.getElementById('recapSecondaryTitle');
                if (recapSecondaryTitle && prenomSec && prenomSec !== '-') recapSecondaryTitle.textContent = prenomSec;
                const recapLienLabel = document.getElementById('recapLienLabel');
                if (recapLienLabel && prenom && prenom !== '-') recapLienLabel.textContent = 'Lien avec ' + prenom;
                const recapSecondaryCard = document.getElementById('recapSecondaryCard');
                if (recapSecondaryCard) recapSecondaryCard.style.display = 'block';
                const recapCardsContainer = document.getElementById('recapCardsContainer');
                if (recapCardsContainer) recapCardsContainer.style.gridTemplateColumns = '1fr 1fr';
                const recapChar2Container = document.getElementById('recapChar2Container');
                if (recapChar2Container) recapChar2Container.style.display = 'block';
                const imageUrl2 = window.characterImageUrls?.personnage2;
                if (imageUrl2) {
                    const recapImageContainer = document.querySelector('#recapChar2Container .character-canvas');
                    if (recapImageContainer) {
                        recapImageContainer.innerHTML = '<img src="'+imageUrl2+'" style="width: 100%; height: 100%; object-fit: contain;">';
                    }
                }
            } else {
                const recapSecondaryCard = document.getElementById('recapSecondaryCard');
                if (recapSecondaryCard) recapSecondaryCard.style.display = 'none';
                const recapChar2Container = document.getElementById('recapChar2Container');
                if (recapChar2Container) recapChar2Container.style.display = 'none';
            }
            generateCharacterScreenshot(false).then(imageDataUrl => {
                const imageUrl = window.characterImageUrls?.personnage1;
                if (imageUrl) {
                    const recapImageContainer = document.querySelector('#stepRecap .character-canvas');
                    if (recapImageContainer) {
                        recapImageContainer.innerHTML = '<img src="'+imageUrl+'" style="width: 100%; height: 100%; object-fit: contain;">';
                    }
                }
            }).catch(error => {
                console.error('❌ Erreur:', error);
            });
        }
        function validateStep2() {
            const prenomEl = document.getElementById('prenom');
            const ageEl = document.getElementById('age');
            const prenom = prenomEl ? prenomEl.value.trim() : '';
            const age = ageEl ? ageEl.value.trim() : '';
            if (!prenom || !age) { alert('Veuillez remplir tous les champs obligatoires'); return false; }
            return true;
        }
        function validateStep5() {
            if (hasSecondaryCharacter) {
                const prenomSecEl = document.getElementById('prenomSecondaire');
                const ageSecEl = document.getElementById('ageSecondaire');
                const prenomSec = prenomSecEl ? prenomSecEl.value.trim() : '';
                const ageSec = ageSecEl ? ageSecEl.value.trim() : '';
                if (!prenomSec || !ageSec) { alert('Veuillez remplir tous les champs obligatoires du personnage secondaire'); return false; }
            }
            return true;
        }
        const nextBtnEl = document.getElementById('nextBtn');
        if (nextBtnEl) {
            nextBtnEl.onclick = () => {
                if (currentStepNum === 2 && !validateStep2()) return;

                const totalSteps = 3;

                if (currentStepNum === 1 && typeof window.capturePersonnage1 === 'function') {
                    window.capturePersonnage1().catch(() => {});
                }

                if (currentStepNum === 2 && !getAbonnementChoice()) {
                    alert('Veuillez d\'abord choisir une formule ci-dessus.');
                    const plansSection = document.querySelector('.lv-sub__container-root, [id^="lv-sub-"]') || document.querySelector('[class*="lv-sub-"]');
                    if (plansSection) plansSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    return;
                }

                if (currentStepNum < totalSteps) {
                    showStep(currentStepNum + 1);
                }
            };
        }
        const prevBtnEl = document.getElementById('prevBtn');
        if (prevBtnEl) {
            prevBtnEl.onclick = () => {
                if (currentStepNum > 1) {
                    showStep(currentStepNum - 1);
                }
            };
        }
        async function generateCharacterScreenshot(isSecondary = false) {
            return new Promise((resolve) => {
                const canvas = document.createElement('canvas');
                canvas.width = 200;
                canvas.height = 280;
                const ctx = canvas.getContext('2d');
                const layers = isSecondary ? [
                    document.getElementById('base2Layer'),
                    document.getElementById('skin2Layer'),
                    document.getElementById('eyebrows2Layer'),
                    document.getElementById('eyes2Layer'),
                    document.getElementById('freckles2Layer'),
                    document.getElementById('hair2Layer'),
                    document.getElementById('glasses2Layer'),
                    document.getElementById('accessories2Layer')
                ] : [
                    document.getElementById('baseLayer'),
                    document.getElementById('skinLayer'),
                    document.getElementById('eyebrowsLayer'),
                    document.getElementById('eyesLayer'),
                    document.getElementById('frecklesLayer'),
                    document.getElementById('hairLayer'),
                    document.getElementById('glassesLayer'),
                    document.getElementById('accessoriesLayer')
                ];
                const visibleLayers = layers.filter(img => 
                    img && img.src && img.style.display !== 'none'
                );
                if (visibleLayers.length === 0) {
                    resolve(null);
                    return;
                }
                let loaded = 0;
                visibleLayers.forEach(layer => {
                    const img = new Image();
                    img.crossOrigin = 'anonymous';
                    img.onload = function() {
                        const top = parseFloat(layer.style.top) || 0;
                        const transform = layer.style.transform || '';
                        const scaleMatch = transform.match(/scale\(([^)]+)\)/);
                        const translateMatch = transform.match(/translateX\(calc\(-50% \+ ([^)]+)px\)\)/);
                        const scale = scaleMatch ? parseFloat(scaleMatch[1]) : 1;
                        const translateX = translateMatch ? parseFloat(translateMatch[1]) : 0;
                        ctx.save();
                        const x = canvas.width / 2 + translateX;
                        const y = (canvas.height * (top / 100));
                        ctx.translate(x, y);
                        ctx.scale(scale, scale);
                        ctx.drawImage(img, -img.width / 2, 0);
                        ctx.restore();
                        loaded++;
                        if (loaded === visibleLayers.length) {
                            const base64 = canvas.toDataURL('image/png', 0.8);
                            resolve(base64);
                        }
                    };
                    img.onerror = function() {
                        loaded++;
                        if (loaded === visibleLayers.length) {
                            const base64 = canvas.toDataURL('image/png', 0.8);
                            resolve(base64);
                        }
                    };
                    img.src = layer.src;
                });
            });
        }
        const validateBtnEl = document.getElementById('validateBtn');
        if (validateBtnEl) {
            validateBtnEl.onclick = async function() {
                const btn = this;
                btn.disabled = true;
                btn.textContent = 'Préparation...';
                const prenomEl = document.getElementById('prenom');
                const ageEl = document.getElementById('age');
                const revesEl = document.getElementById('reves');
                const dedicaceEl = document.getElementById('dedicace');
                const prenom = prenomEl ? prenomEl.value.trim() : '';
                const age = ageEl ? ageEl.value.trim() : '';
                const reves = revesEl ? revesEl.value.trim() : '';
                const dedicace = dedicaceEl ? dedicaceEl.value.trim() : '';
                const genderName = gender === 'boy' ? 'Garçon' : 'Fille';
                const choice = getAbonnementChoice();
                if (!choice) {
                    alert('Veuillez d\'abord choisir une formule ci-dessus.');
                    btn.disabled = false;
                    btn.textContent = 'Ajouter au panier';
                    return;
                }
                const properties = {
                    '--- INFORMATIONS ---': '',
                    'Couverture': choice.label,
                    'Fréquence': choice.freq === 'annual' ? 'Annuel' : 'Mensuel'
                };
                if (dedicace) properties['Dédicace'] = dedicace;
                properties['--- PERSONNAGE PRINCIPAL ---'] = '';
                properties['Prénom'] = prenom;
                properties['Âge'] = age + ' ans';
                properties['Genre'] = genderName;
                if (reves) properties['Rêves & Intérêts'] = reves;
                const anecdotesEl = document.getElementById('anecdotes');
                const anecdotes = anecdotesEl ? anecdotesEl.value.trim() : '';
                if (anecdotes) properties['Histoires vécues'] = anecdotes;
                if (window.characterImageUrls && window.characterImageUrls.personnage1) {
                    properties['_Image'] = window.characterImageUrls.personnage1;
                }
                properties['_Coupe'] = styles[styleIdx].name;
                properties['_Couleur'] = colors[colorIdx].name;
                properties['_Yeux'] = eyesOptions[eyesIdx].name;
                properties['_Sourcils'] = eyebrowsOptions[eyebrowsIdx].name;
                properties['_Taches de rousseur'] = frecklesIdx > 0 ? 'Oui' : 'Non';
                properties['_Lunettes'] = glassesIdx > 0 ? glassesOptions[glassesIdx].name : 'Non';
                properties['_Accessoires'] = accessoriesIdx > 0 ? accessoriesOptions[accessoriesIdx].name : 'Non';
                if (gender === 'girl' && typeof OUTFITS_GIRL !== 'undefined') properties['_Tenue'] = OUTFITS_GIRL[outfitIdx].name;
                try {
                    btn.textContent = 'Ajout au panier...';
                    const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: choice.variantId, quantity: 1, properties: properties, selling_plan: choice.sellingPlanId })
                    });
                    if (response.ok) window.location.href = '/cart';
                    else throw new Error('Erreur HTTP');
                } catch (error) {
                    alert('Erreur lors de l\'ajout au panier: ' + error.message);
                    console.error(error);
                }
                btn.disabled = false;
                btn.textContent = 'Ajouter au panier';
            };
        }
        update();
        updateProgressBar();
        showStep(1);
        var lvRoot = document.getElementById('character-builder-abonnement-root');
        if (lvRoot) {
            lvRoot.addEventListener('lv:abonnement-choice-updated', function() {
                if (currentStepNum === 3) updateRecap();
            });
        }
        const prenomInput = document.getElementById('prenom');
        const prenomSecInput = document.getElementById('prenomSecondaire');
        function capitalizeInput(input) {
            if (!input) return;
            input.addEventListener('blur', function() {
                const value = this.value.trim();
                if (value) { this.value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(); updateProgressLabels(); }
            });
        }
        capitalizeInput(prenomInput);
        capitalizeInput(prenomSecInput);
        function updateStepProgress(stepElement, progress) {
            const circle = stepElement.querySelector('.progress-ring-fill');
            const circumference = 2 * Math.PI * 21;
            const offset = circumference - (progress * circumference);
            if (circle) circle.style.strokeDashoffset = offset;
            const icon = stepElement.querySelector('.edit-icon');
            if (icon) icon.style.display = progress >= 1 ? 'block' : 'none';
        }
        const navContainer = document.querySelector('.nav-container');
        const container = document.querySelector('.container');
        handleScrollFunc = function() {
            if (!navContainer || !container) return;
            const totalSteps = 3;
            const isRecapStep = currentStepNum === totalSteps;
            if (!isRecapStep) { navContainer.classList.remove('floating'); return; }
            const containerRect = container.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            if (containerRect.bottom > windowHeight && containerRect.top < windowHeight) navContainer.classList.add('floating');
            else navContainer.classList.remove('floating');
        };
        window.addEventListener('scroll', handleScrollFunc);
        window.addEventListener('resize', handleScrollFunc);
        handleScrollFunc();
        document.querySelectorAll('.progress-step').forEach(step => {
            step.addEventListener('click', function() {
                const stepData = this.dataset.step;
                if (!stepData) return;
                let targetStep;
                let isAccessible = false;
                if (stepData === 'perso1') { targetStep = 2; isAccessible = true; }
                else if (stepData === 'recap') { targetStep = 3; isAccessible = currentStepNum >= 3; }
                if (targetStep && isAccessible) showStep(targetStep);
                else if (!isAccessible) { this.style.animation = 'shake 0.3s'; setTimeout(() => { this.style.animation = ''; }, 300); }
            });
        });
        const scaleSlider = document.getElementById('scaleSlider');
        const topSlider = document.getElementById('topSlider');
        const leftSlider = document.getElementById('leftSlider');
        const scaleValue = document.getElementById('scaleValue');
        const topValue = document.getElementById('topValue');
        const leftValue = document.getElementById('leftValue');
        const scale2Slider = document.getElementById('scale2Slider');
        const top2Slider = document.getElementById('top2Slider');
        const left2Slider = document.getElementById('left2Slider');
        const scale2Value = document.getElementById('scale2Value');
        const top2Value = document.getElementById('top2Value');
        const left2Value = document.getElementById('left2Value');
        function applyManualTransform() {
            const scale = scaleSlider ? scaleSlider.value / 100 : 0.5;
            const top = topSlider ? topSlider.value : -12;
            const left = leftSlider ? leftSlider.value : 0;
            const scale2 = scale2Slider ? scale2Slider.value / 100 : 0.5;
            const top2 = top2Slider ? top2Slider.value : -12;
            const left2 = left2Slider ? left2Slider.value : 0;
            if (currentCategory === 'hair') {
                if (gender === 'girl' && eyebrows && eyebrows.style.display !== 'none') {
                    eyebrows.style.top = top + '%';
                    eyebrows.style.left = '50%';
                    eyebrows.style.transform = 'translateX(calc(-50% + ' + left + 'px)) scale(' + scale + ')';
                } else if (hair && hair.style.display !== 'none') {
                    hair.style.top = top + '%';
                    hair.style.left = '50%';
                    hair.style.transform = 'translateX(calc(-50% + ' + left + 'px)) scale(' + scale + ')';
                }
            } else if (currentCategory === 'accessories') {
                if (accessories && accessories.style.display !== 'none') {
                    accessories.style.top = top + '%';
                    accessories.style.left = '50%';
                    accessories.style.transform = 'translateX(calc(-50% + ' + left + 'px)) scale(' + scale + ')';
                }
            } else if (currentCategory === 'glasses') {
                if (glasses && glasses.style.display !== 'none') {
                    glasses.style.top = top + '%';
                    glasses.style.left = '50%';
                    glasses.style.transform = 'translateX(calc(-50% + ' + left + 'px)) scale(' + scale + ')';
                }
            } else if (currentCategory === 'eyebrows') {
                if (eyebrows && eyebrows.style.display !== 'none') {
                    eyebrows.style.top = top + '%';
                    eyebrows.style.left = '50%';
                    eyebrows.style.transform = 'translateX(calc(-50% + ' + left + 'px)) scale(' + scale + ')';
                }
            }
            if (currentCategory2 === 'hair') {
                if (gender2 === 'girl' && eyebrows2 && eyebrows2.style.display !== 'none') {
                    eyebrows2.style.top = top2 + '%';
                    eyebrows2.style.left = '50%';
                    eyebrows2.style.transform = 'translateX(calc(-50% + ' + left2 + 'px)) scale(' + scale2 + ')';
                } else if (hair2 && hair2.style.display !== 'none') {
                    hair2.style.top = top2 + '%';
                    hair2.style.left = '50%';
                    hair2.style.transform = 'translateX(calc(-50% + ' + left2 + 'px)) scale(' + scale2 + ')';
                }
            } else if (currentCategory2 === 'accessories') {
                if (accessories2 && accessories2.style.display !== 'none') {
                    accessories2.style.top = top2 + '%';
                    accessories2.style.left = '50%';
                    accessories2.style.transform = 'translateX(calc(-50% + ' + left2 + 'px)) scale(' + scale2 + ')';
                }
            } else if (currentCategory2 === 'glasses') {
                if (glasses2 && glasses2.style.display !== 'none') {
                    glasses2.style.top = top2 + '%';
                    glasses2.style.left = '50%';
                    glasses2.style.transform = 'translateX(calc(-50% + ' + left2 + 'px)) scale(' + scale2 + ')';
                }
            } else if (currentCategory2 === 'eyebrows') {
                if (eyebrows2 && eyebrows2.style.display !== 'none') {
                    eyebrows2.style.top = top2 + '%';
                    eyebrows2.style.left = '50%';
                    eyebrows2.style.transform = 'translateX(calc(-50% + ' + left2 + 'px)) scale(' + scale2 + ')';
                }
            }
        }
        if (scaleSlider) scaleSlider.oninput = function() { scaleValue.textContent = this.value; applyManualTransform(); };
        if (topSlider) topSlider.oninput = function() { topValue.textContent = this.value; applyManualTransform(); };
        if (leftSlider) leftSlider.oninput = function() { leftValue.textContent = this.value; applyManualTransform(); };
        if (scale2Slider) scale2Slider.oninput = function() { scale2Value.textContent = this.value; applyManualTransform(); };
        if (top2Slider) top2Slider.oninput = function() { top2Value.textContent = this.value; applyManualTransform(); };
        if (left2Slider) left2Slider.oninput = function() { left2Value.textContent = this.value; applyManualTransform(); };
    }
})();
